import React, { useState, useEffect } from 'react';

import { Dialog } from '@headlessui/react';

export default function DigItemCart({ onClose, ordItems, item, status }) {

    const [mainItems, setMainItems] = useState([]);
    const [originalItems, setOriginalItems] = useState([]);

    const handleAddNew = () => {
        onClose({ action: "addnew", data: [] });
    };

    const getAddonString = (items) => {
        if (!items || items.length === 0) return "";
        return items.map((i) => i.name).join(", ") + ".";
    };

    const addItem = (index) => {
        const updated = [...mainItems];
        updated[index].qty += 1;
        setMainItems(updated);
        updateItems(updated);
    };

    const removeItem = (index) => {
        const updated = [...mainItems];
        updated[index].qty -= 1;
        if (updated[index].qty === 0) {
            updated.splice(index, 1);
        }
        setMainItems(updated);
        updateItems(updated);
    };

    const updateItems = (updatedMain) => {
        const newOriginal = originalItems.filter((i) => i.id !== item.id);
        newOriginal.push(...updatedMain);
        setOriginalItems(newOriginal);
        if (updatedMain.length === 0) {
            onClose({ action: "empty", data: [] });
        } else {
            onClose({ action: "update", data: newOriginal });
        }
    };

    useEffect(() => {
        if (ordItems) {
            setOriginalItems([...ordItems]);
            setMainItems(ordItems.filter((a) => a.id === item.id));
        }
    }, [ordItems, item]);

    return (
        <Dialog open={status} onClose={() => { onClose(null); }} className='overflow-y-auto overflow-x-hidden z-[100] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
            <div className="relative w-full max-w-2xl h-full md:h-auto mx-auto bg-white shadow-lg rounded-md mt-10 p-4">
                <div className='flex items-center justify-between'>
                    <h3 className="text-xl font-semibold text-gray-900">
                        {item.name} &nbsp;
                    </h3>
                    <span className='bg-gray-200 hover:bg-gray-100 w-8 h-8 rounded-full cursor-pointer flex items-center justify-center' onClick={() => {
                        onClose(null);
                    }}>
                        <i className="las la-times text-sm text-black"></i>
                    </span>
                </div>
                <hr className='my-2' />
                <div className="bg-white rounded border p-2">
                    {
                        mainItems.map((item, index) => (
                            <div key={index} className="flex items-center justify-between py-2 border-b last:border-none">
                                <div>
                                    <div className="text-sm font-medium">{item.name}</div>
                                    <div className="text-xs text-gray-500">
                                        {getAddonString(item.addons)}
                                    </div>
                                </div>
                                <div className="flex items-center gap-3">
                                    <span className="text-sm">{item.price} ₹</span>
                                    <div className="flex items-center bg-gray-800 text-white rounded px-2 w-20 justify-between">
                                        <button onClick={() => removeItem(index)}>-</button>
                                        <span className="text-sm">{item.qty}</span>
                                        <button onClick={() => addItem(index)}>+</button>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div className='my-2' />
                <div className='w-full flex items-center justify-end space-x-2'>
                    <button onClick={() => onClose(null)} className="w-[140px] py-2 text-prime border border-prime rounded-lg">
                        Cancel
                    </button>
                    <button onClick={handleAddNew} className="w-[140px] py-2 bg-prime text-white font-medium rounded-lg">
                        ADD NEW
                    </button>
                </div>
            </div>
        </Dialog>
    )
}
